import React, { createRef, useEffect, useState } from 'react';
import { Image, Popover, Skeleton } from '@nackle/paper';
import recognitionService, { RecService } from '../../../services/recognition';
import bannerImage from '../../../assets/bannerImage.png';
import logoutIcon from '../../../assets/logout.png';
import menuIcon from '../../../assets/menu.png';

export default function Header( props ) {
    const { user } = props;
    const menuPopupRef = createRef();
    const [ menuVisible, setMenuVisible ] = useState( false );
    const [ menuInfo, setMenuInfo ] = useState( {} ); 
    
    useEffect( () => {
        const fetchMenuInfo = async () => {
            const pointsResponse = await recognitionService.getPoints( user.claims.person_id );
            const pointsJson = await pointsResponse.json();
            
            const mediaResponse = await recognitionService.getMediaLabel();
            const mediaJson = await mediaResponse.json();
            
            const recService = new RecService( user.claims.company_id );
            const catalogMenuResponse = await recService.getMarketplaceItems( user.claims.person_id, user.claims.country );
            
            const merchUrlResp = await recognitionService.getMerchUrl( user.claims.person_id );
            const merchUrlJson = await merchUrlResp.json();
            
            const expUrlResp = await recognitionService.getExpUrl( user.claims.person_id );
            const expUrlJson = await expUrlResp.json();

            setMenuInfo( { 
                balance: pointsJson.accountBalance,
                mediaLabel: mediaJson.solutions[ 0 ].mediaLabel,
                catalogMenuItems: catalogMenuResponse,
                merchUrl: merchUrlJson.shopUrl,
                expUrl: expUrlJson.shopUrl,
                headerLoaded: true } );
        };
        fetchMenuInfo();
    }, [] );
    
    const handleMenuVisibleChange = visible => {
        setMenuVisible( visible );
    };
        
    return (
        <div style={ { display: 'flex', padding: '10px',
            backgroundColor: '#e4e6eb',
            alignItems: 'center', overflow: 'auto' } }>
                <div>
                    <Image preview={ false } src={ bannerImage } style={ { height: '30px' } } />
                </div>
                <div className='header-menu-container' ref={ menuPopupRef }>
                <Popover
                        placement='bottomLeft'
                        visible={ menuVisible }
                        trigger='click'
                        onVisibleChange={ handleMenuVisibleChange }
                        getPopupContainer={ () => menuPopupRef.current }
                        content={
                            menuInfo.headerLoaded ? (
                            <div>
                                
                            <div style={ { fontSize: '14px', paddingRight: '16px', paddingLeft: '16px' } }>
                                Shop rewards
                            </div>
                            <div style={ { display: 'flex', flexDirection: 'col', alignItems: 'center', paddingLeft: '16px', paddingRight: '16px' } }>
                                <div style={ { fontSize: '24px', fontWeight: 'bold', paddingRight: '5px' } }>
                                    { menuInfo.balance }
                                </div>
                                <div style={ { fontSize: '18px' } }>
                                    { menuInfo.mediaLabel }
                                </div>
                            </div>
                            <div style={ { display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingBottom: '30px', paddingRight: '16px', paddingLeft: '16px' } }>
                            { menuInfo.catalogMenuItems && menuInfo.catalogMenuItems.length > 0 &&
                                
                                    menuInfo.catalogMenuItems.map( ( item ) => (
                                    
                                    <div key={ item.pageType }
                                            onClick={ () => window.open( item.pageType === 'merchandise' ? menuInfo.merchUrl : menuInfo.expUrl, '_blank' ) }
                                            style={ { display: 'flex', 
                                                    flexDirection: 'column', 
                                                    justifyContent: 'center', 
                                                    alignItems: 'center', 
                                                    borderStyle: 'solid', 
                                                    borderRadius: '4px', 
                                                    borderWidth: '1px', 
                                                    paddingTop: '10px', 
                                                    paddingBottom: '10px', 
                                                    width: '110px' } }>
                                        <Image src={ item.colorLogo } preview={ false } width={ 45 }/>
                                        <div style={ { textAlign: 'center' } }>
                                            { `Shop ${ item.pageType }` }
                                        </div>
                                    </div>
                                    ) )
                            }
                            </div>
                            <div onClick={ ( e ) => {
                                        window.parent.postMessage( { logout: true }, '*' );
                                    } } style={ { display: 'flex', alignItems: 'center', marginTop: 'auto', borderTopWidth: '1px', borderTopStyle: 'solid', height: '55px' } }>
                                <div style={ { paddingLeft: '16px' } }>
                                    Logout
                                </div>
                                <div style={ { paddingRight: '16px', marginLeft: 'auto' } }>
                                <Image src={ logoutIcon } preview={ false } height={ 30 } />
                                </div>
                                
                            </div>
                                
                            </div>
                            ) :
                                (
                                    <div>
                                        <div style={ { fontSize: '14px', paddingRight: '16px', paddingLeft: '16px', paddingBottom: '5px' } }>
                                            <Skeleton.Input style={ { minWidth: '50px', width: '50px', height: '14px' } } active />
                                        </div>
                                        <div style={ { display: 'flex', flexDirection: 'col', alignItems: 'center', paddingLeft: '16px', paddingRight: '16px' } }>
                                            <div style={ { fontSize: '24px', fontWeight: 'bold', paddingRight: '5px' } }>
                                                <Skeleton.Input style={ { minWidth: '100px', width: '100px', height: '24px' } } active />
                                            </div>
                                            <div style={ { fontSize: '18px' } }>
                                                <Skeleton.Input style={ { minWidth: '50px', width: '50px', height: '18px' } } active />
                                            </div>
                                        </div>
                                        <div style={ { display: 'flex', flexDirection: 'row', justifyContent: 'center', paddingBottom: '30px', paddingRight: '16px', paddingLeft: '16px' } }>
                                            <div style={ { display: 'flex', 
                                                            flexDirection: 'column', 
                                                            justifyContent: 'center', 
                                                            alignItems: 'center', 
                                                            borderStyle: 'solid', 
                                                            borderRadius: '4px', 
                                                            borderWidth: '1px', 
                                                            paddingTop: '10px', 
                                                            paddingBottom: '10px', 
                                                            width: '110px' } }>
                                                <Skeleton.Image style={ { width: '45px', height: '45px' } } acitve />
                                                <div style={ { textAlign: 'center', paddingTop: '5px' } }>
                                                    <Skeleton.Input style={ { minWidth: '50px', width: '50px', height: '14px' } } active  />
                                                </div>
                                            </div>
                                        </div>
                                        <div style={ { display: 'flex', alignItems: 'center', marginTop: 'auto', borderTopWidth: '1px', borderTopStyle: 'solid', height: '55px' } }>
                                            <div style={ { paddingLeft: '16px', paddingRight: '16px' } }>
                                                <Skeleton.Button active />
                                            </div>
                                        </div>
                                    </div>
                                )
                            }>
                        <Image src={ menuIcon } preview={ false } height={ 30 }  />
                    </Popover>
                </div> 
            </div>
    );

}
